<script setup>
import { computed } from "vue";
import STATUS_TONE_MAP from "@/Constans/StatusToneMap";

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  value: {
    type: [String, Number],
    default: 0,
  },
  current: {
    type: [String, Number],
    default: 0,
  },
  total: {
    type: [String, Number],
    default: 0,
  },
  percentage: {
    type: [String, Number],
    default: 0,
  },
  progressColor: {
    type: String,
    default: "cancelado",
  },
  metaLabel: {
    type: String,
    default: "",
  },
  // El propio valor (arriba) ya es un porcentaje: current/total/percentage
  // serian el mismo numero repetido (p.ej. "81,52 / 100" y una badge "82%"
  // junto a un valor de "81,5%") — se oculta toda la fila para no duplicar.
  isPercentageMetric: {
    type: Boolean,
    default: false,
  },
});

const formattedPercent = computed(() => `${normalizePercent(props.percentage)}%`);
const resolvedTone = computed(
  () => STATUS_TONE_MAP[props.progressColor] || STATUS_TONE_MAP.cancelado
);
const progressStyle = computed(() => ({
  width: `${normalizePercent(props.percentage)}%`,
  backgroundColor: resolvedTone.value.border,
}));

function normalizePercent(value) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return 0;
  return Math.max(0, Math.min(100, Math.round(parsed)));
}
</script>

<template>
  <div class="card card-detail-layout h-100">
    <div class="card-header pb-0">
      <p class="text-xs text-uppercase text-secondary font-weight-bolder mb-0">
        {{ title }}
      </p>
    </div>
    <div class="card-body  pb-2">
      <h5 class="mb-2">{{ value }}</h5>
      <div class="progress mb-1">
        <div class="progress-bar" :style="progressStyle"></div>
      </div>
      <div
        v-if="!isPercentageMetric"
        class="d-flex justify-content-between align-items-center text-xs text-secondary"
      >
        <span>{{ current }} / {{ total }}</span>
        <span>{{ formattedPercent }}</span>
      </div>
      <p class="text-xs text-secondary mb-0 text-capitalize">
        {{ metaLabel }}
      </p>
    </div>
  </div>
</template>


